
















import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class ErrorTemplate extends Vue {
  private created() {
    // console.log(this.$route.params);
  }
}
